import { MenuItem } from '../types';

export const menuItems: MenuItem[] = [
  // Appetizers/Sides
  {
    id: 'chicken-wings',
    name: 'Chicken Wings',
    description: '6 pcs | 12 pcs - Plain, Lemon Pepper, Barbeque, Spicy Honey Garlic, Buffalo, Garlic Buffalo, Mango Habanero',
    basePrice: 8.00, // 6 pcs, 12 pcs is $14
    image: '/HotSlicePizza_ChickenWings.jpg',
    category: 'appetizers'
  },
  {
    id: 'garlic-breadsticks',
    name: 'Garlic bites (served with marinara sauce)',
    description: 'Garlic Breadsticks (served with marinara sauce) - Crispy, toasty breadsticks topped with garlic, unsalted butter, and herbs.',
    basePrice: 8.00,
    image: '/HotSlicePizza_GarlicBread.jpg',
    category: 'appetizers'
  },
  {
    id: 'garlic-cheese-breadsticks',
    name: 'Cheese Garlic Breadsticks (served with marinara sauce)',
    description: 'Garlic Cheese Breadsticks (served with marinara sauce) - Crispy breadsticks topped with garlic, herbs, and melted mozzarella cheese.',
    basePrice: 9.00,
    image: '/HotSlicePizza_GarlicCheeseBread.jpg',
    category: 'appetizers'
  },

  // Pizzas
  {
    id: 'hot-slice-supreme',
    name: 'Hot Slice Supreme',
    description: 'Pizza sauce base, beef bacon bits, Italian sausage, red onions, mushrooms, black olives, pepperoni, oregano, and mozzarella cheese.',
    basePrice: 21.99,
    image: '/HotSlicePizza_SupremePizza.jpg',
    category: 'pizza',
    sizes: { medium: 21.99, large: 26.99, xlarge: 31.99 }
  },
  {
    id: 'classic-cheese-pizza',
    name: 'Classic Cheese Pizza',
    description: 'Pizza sauce base, mozzarella cheese, parmesan cheese, and oregano.',
    basePrice: 19.99,
    image: '/classic-cheese-pizza.jpg',
    category: 'pizza',
    sizes: { medium: 19.99, large: 24.99, xlarge: 29.99 }
  },
  {
    id: 'meat-lover-pizza',
    name: 'Meat Lover Pizza',
    description: 'Pizza sauce base, pepperoni, chicken, Italian sausage, mozzarella cheese, oregano, and beef bacon bits.',
    basePrice: 21.99,
    image: '/HotSlicePizza_MeatLoverPizza.jpg',
    category: 'pizza',
    sizes: { medium: 21.99, large: 26.99, xlarge: 31.99 }
  },
  {
    id: 'chicken-ranch-pizza',
    name: 'Chicken Ranch Pizza',
    description: 'Ranch sauce base, grilled chicken breast, roasted garlic, red onions, beef bacon bits, oregano, and tomatoes.',
    basePrice: 21.99,
    image: '/chicken-ranch-pizza.jpg',
    category: 'pizza',
    sizes: { medium: 21.99, large: 26.99, xlarge: 31.99 }
  },
  {
    id: 'hot-hawaiian-pizza',
    name: 'Hot Hawaiian Pizza',
    description: 'Pizza sauce base, pepperoni, mozzarella cheese, jalapeño, and pineapple.',
    basePrice: 21.99,
    image: '/hot-hawaiian-pizza.jpg',
    category: 'pizza',
    sizes: { medium: 21.99, large: 26.99, xlarge: 31.99 }
  },
  {
    id: 'margherita-pizza',
    name: 'Margherita Pizza',
    description: 'Pizza sauce base, fresh mozzarella, garnished with fresh basil.',
    basePrice: 19.99,
    image: '/HotSlicePizza_MargheritaPizza.jpg',
    category: 'pizza',
    sizes: { medium: 19.99, large: 24.99, xlarge: 29.99 }
  },
  {
    id: 'barbecue-chicken-pizza',
    name: 'Barbecue Chicken Pizza',
    description: 'Chicken, onions, green peppers, mozzarella, oregano, topped with drizzle of BBQ sauce.',
    basePrice: 21.99,
    image: '/HotSlicePizza_BBQChickenPizza.jpg',
    category: 'pizza',
    sizes: { medium: 21.99, large: 26.99, xlarge: 31.99 }
  },
  {
    id: 'buffalo-chicken-pizza',
    name: 'Buffalo Chicken Pizza',
    description: 'Pizza sauce base, mozzarella cheese, parmesan, onions, jalapeño, chicken, oregano, topped with buffalo sauce.',
    basePrice: 21.99,
    image: '/HotSlicePizza_BuffaloChickenPizza.jpg',
    category: 'pizza',
    sizes: { medium: 21.99, large: 26.99, xlarge: 31.99 }
  },
  {
    id: 'classic-pepperoni-pizza',
    name: 'Classic Pepperoni Pizza',
    description: 'Pizza sauce base, pepperoni, parmesan and mozzarella cheese.',
    basePrice: 19.99,
    image: '/Pepperoni Pizza.jpg',
    category: 'pizza',
    sizes: { medium: 19.99, large: 24.99, xlarge: 29.99 }
  },
  {
    id: 'chefs-garden-pizza',
    name: 'Chef\'s Garden Pizza',
    description: 'Pizza sauce base, mushrooms, onions, black olives, green peppers, mozzarella cheese, oregano, and tomatoes.',
    basePrice: 21.99,
    image: '/chefs-garden.jpg',
    category: 'pizza',
    sizes: { medium: 21.99, large: 26.99, xlarge: 31.99 }
  },
  {
    id: 'chicken-pesto-pizza',
    name: 'Chicken Pesto Pizza',
    description: 'Basil pesto sauce base, grilled chicken breast, red onions, mushrooms, mozzarella cheese, oregano, and feta cheese.',
    basePrice: 21.99,
    image: '/HotSlicePizza_ChickenPestoPizza.jpg',
    category: 'pizza',
    sizes: { medium: 21.99, large: 26.99, xlarge: 31.99 }
  },

  // Calzones
  {
    id: 'bbq-chicken-calzone',
    name: 'BBQ Chicken Calzone',
    description: 'Stuffed with chicken, onions, mozzarella cheese, Ricotta cheese, BBQ sauce, cheddar cheese, and brushed with olive oil.',
    basePrice: 14.00,
    image: '/bbq-chicken-calzone.jpg',
    category: 'calzones'
  },
  {
    id: 'house-special-calzone',
    name: 'House Special Calzone',
    description: 'Stuffed with onions, black olives, chicken, mozzarella cheese, Ricotta cheese, spinach, and brushed with olive oil.',
    basePrice: 14.00,
    image: '/House Calzone.jpg',
    category: 'calzones'
  },
  {
    id: 'pepperoni-calzone',
    name: 'Pepperoni Calzone',
    description: 'Stuffed with pepperoni, mozzarella cheese, Ricotta cheese, and brushed with olive oil.',
    basePrice: 14.00,
    image: '/Pepperoni Calzone.jpg',
    category: 'calzones'
  },
  {
    id: 'meat-lover-calzone',
    name: 'Meat Lover Calzone',
    description: 'Stuffed with pepperoni, chicken, bacon, mozzarella cheese, Ricotta cheese, and brushed with olive oil.',
    basePrice: 14.00,
    image: '/Meatlovers Calzone.jpg',
    category: 'calzones'
  },
  {
    id: 'veggie-zone-calzone',
    name: 'The Veggie Zone',
    description: 'Stuffed with spinach, black olives, onions, mushrooms, green pepper, mozzarella cheese, Ricotta cheese, and brushed with olive oil.',
    basePrice: 14.00,
    image: '/HotSlicePizza_VeggieCalzone.jpg',
    category: 'calzones'
  },

  // Pasta
  {
    id: 'four-cheese-baked-spaghetti',
    name: 'Four Cheese Baked Spaghetti',
    description: 'Spaghetti noodles baked in homemade marinara sauce and smothered in four different cheeses.',
    basePrice: 12.00,
    image: '/HotSlicePizza_FourCheeseBakedSpaghetti.jpg',
    category: 'pasta'
  },
  {
    id: 'spaghetti',
    name: 'Spaghetti',
    description: 'Spaghetti with Meatballs - Classic spaghetti noodles with homemade meatballs in rich marinara sauce.',
    basePrice: 14.00,
    image: '/HotSlicePizza_SpaghettiWithMeatballs.jpg',
    category: 'pasta'
  },
  {
    id: 'chicken-parmesan-pasta',
    name: 'Chicken Parmesan Pasta',
    description: 'Breaded chicken breast baked with homemade marinara sauce, topped with mozzarella and Parmesan cheese on a bed of spaghetti.',
    basePrice: 14.00,
    image: '/HotSlicePizza_ChickenParmesan.jpg',
    category: 'pasta'
  },
  {
    id: 'rigatoni-bolognese',
    name: 'Rigatoni Bolognese',
    description: 'Rigatoni Bolognese (w/ Italian sausage) - Rigatoni pasta with rich, hearty meat sauce made with Italian sausage and herbs.',
    basePrice: 14.00,
    image: '/rigatoni-bolognese.jpg',
    category: 'pasta'
  },
  {
    id: 'chicken-fettuccine-alfredo',
    name: 'Chicken Fettuccine Alfredo',
    description: 'Chicken Fettuccine Alfredo - Fettuccine noodles with grilled chicken in creamy alfredo sauce.',
    basePrice: 14.00,
    image: '/HotSlicePizza_ChickenFettuccineAlfredo.jpg',
    category: 'pasta'
  },
  {
    id: 'baked-cheese-tortellini',
    name: 'Baked Cheese Tortellini',
    description: 'Baked Cheese Tortellini Alfredo - Cheese-filled tortellini baked in creamy alfredo sauce and topped with melted mozzarella.',
    basePrice: 12.00,
    image: '/Tortellini-Casserole-2.webp',
    category: 'pasta'
  },

  // Salads
  {
    id: 'caesar-salad',
    name: 'Caesar Salad',
    description: 'Fresh romaine tossed with Parmesan cheese, croutons, and creamy Caesar dressing.',
    basePrice: 10.00,
    image: '/HotSlicePizza_CeasarSalad.jpg',
    category: 'salads'
  },
  {
    id: 'house-salad',
    name: 'House Salad',
    description: 'Crisp romaine lettuce, tomatoes, cucumbers, red onions, shredded cheese, and crunchy croutons.',
    basePrice: 10.00,
    image: '/HotSlicePizza_HouseSalad.jpg',
    category: 'salads'
  },
  {
    id: 'chicken-avocado-salad',
    name: 'Chicken & Avocado Salad',
    description: 'Grilled chicken breast, creamy avocado, tomatoes, cucumbers, and red onions on a bed of mixed greens.',
    basePrice: 12.00,
    image: '/HotSlicePizza_ChickenAvocadoSalad.jpg',
    category: 'salads'
  },
  {
    id: 'greek-salad',
    name: 'Greek Salad',
    description: 'Crisp romaine lettuce with tomatoes, cucumbers, red onions, olives, and feta cheese. Served with Greek vinaigrette.',
    basePrice: 10.00,
    image: '/HotSlicePizza_GreekSalad.jpg',
    category: 'salads'
  },

  // Desserts
  {
    id: 'gelato',
    name: 'Gelato',
    description: 'Authentic NY style gelato imported straight from Italy. Kids scoop ($4), Single scoop ($5), Double scoop ($7). Available in 9 delicious flavors.',
    basePrice: '$4-$7',
    image: '/HotSlicePizza_Gelato.jpg',
    category: 'desserts'
  },
  {
    id: 'family-warm-treats',
    name: 'Family Warm Treats',
    description: 'Chocolate Chip Cookie, M&M Chocolate Chip, Hersheys Choc. Brownie - perfect for sharing with the family.',
    basePrice: 12.00,
    image: '/cookiepizza.png',
    category: 'desserts'
  },
  {
    id: 'red-velvet-cake',
    name: 'Red Velvet Cake',
    description: 'Rich and moist red velvet cake with smooth cream cheese frosting, topped with red velvet crumbs.',
    basePrice: 8.00,
    image: '/HotSlicePizza_RedVelvetCake.jpg',
    category: 'desserts'
  },
  {
    id: 'ricotta-pistachio-cake',
    name: 'Ricotta Pistachio Cake',
    description: 'Traditional Italian layered cake with creamy ricotta filling and pistachio flavoring, dusted with powdered sugar.',
    basePrice: 8.00,
    image: '/HotSlicePizza_RicottaPistachioCake.jpg',
    category: 'desserts'
  },
  {
    id: 'nutella-cheesecake',
    name: 'Nutella Cheesecake',
    description: 'Rich and creamy Nutella cheesecake with a chocolate cookie crust, topped with crushed hazelnuts and whipped cream.',
    basePrice: 8.00,
    image: '/HotSlicePizza_NutellaCheesecake.jpg',
    category: 'desserts'
  },
  {
    id: 'ny-cheesecake',
    name: 'New York Cheesecake',
    description: 'Classic New York style cheesecake with a graham cracker crust, served with whipped cream.',
    basePrice: 8.00,
    image: '/HotSlicePizza_NYCheesecake.jpg',
    category: 'desserts'
  },

  // Drinks
  {
    id: 'soda-drinks',
    name: 'Soda Drinks',
    description: 'Choose your favorite beverage from our selection.',
    basePrice: 1.99,
    image: 'https://images.pexels.com/photos/50593/coca-cola-cold-drink-soft-drink-coke-50593.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop',
    category: 'drinks'
  },
  {
    id: 'milkshakes',
    name: 'Milkshakes',
    description: 'Creamy milkshakes made with your choice of any of our 9 delicious gelato flavors.',
    basePrice: 8.00,
    image: 'https://images.pexels.com/photos/103566/pexels-photo-103566.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop',
    category: 'drinks'
  },
  {
    id: 'jarritos',
    name: 'Jarritos',
    description: 'Authentic Mexican soda in a variety of refreshing flavors.',
    basePrice: 3.50,
    image: 'https://images.pexels.com/photos/18400436/pexels-photo-18400436.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop',
    category: 'drinks'
  }
];
